import { Pipe, PipeTransform } from '@angular/core';
import { MasterDataColuna } from 'app/interfaces/master-data-coluna';
import { MasterDataTabela } from 'app/interfaces/master-data-tabela';

@Pipe({
  name: 'nomeItemAgregacao'
})
export class NomeItemAgregacao implements PipeTransform {
  transform(item: string | MasterDataColuna, tabelaPrincipal: MasterDataTabela) {
    if ((item as MasterDataColuna).tabela !== undefined) {
      let coluna = item as MasterDataColuna;
      let valorExibicao = '';

        if (coluna.tabelaRelacionada && coluna.tabelaRelacionada !== tabelaPrincipal.nome) {
            valorExibicao += "[" + coluna.tabelaRelacionadaValorExibicao + '.' + coluna.colunaRelacionadaValorExibicao + "] ";
        } else if (coluna.colunaRelacionada) {
            valorExibicao += "[" + coluna.colunaRelacionadaValorExibicao + "] ";
        }

        return valorExibicao + coluna.tabelaValorExibicao + '.' + coluna.valorExibicao;
    } else {
      return item;
    }
  }
}